/**
 * Типы допустимых значений продолжительности
 */
export type DurationIntervalKey = 'upto_2_hours' | 'from_2_to_4_hours' | 'from_4_to_6_hours' | 'from_6_hours';

/**
 * Порядок значений продолжительности
 */
export const DURATION_INTERVAL_ORDER = {
  upto_2_hours: 1,
  from_2_to_4_hours: 2,
  from_4_to_6_hours: 3,
  from_6_hours: 4,
} satisfies Record<DurationIntervalKey, number>;

type DurationIntervalOrderType = Record<string, number | undefined>;

const durationIntervalOrderMap: DurationIntervalOrderType = DURATION_INTERVAL_ORDER;

/**
 * Сортирует значения продолжительности в заданном порядке
 * @param values - массив значений продолжительности
 * @returns отсортированный массив значений
 */
export function sortDurationIntervalValues(values: string[]): string[] {
  return [...values].sort((a, b) => {
    // Используем объект с индексной сигнатурой для безопасного доступа
    const orderA = durationIntervalOrderMap[a] ?? Number.MAX_SAFE_INTEGER;
    const orderB = durationIntervalOrderMap[b] ?? Number.MAX_SAFE_INTEGER;

    return orderA - orderB;
  });
}
